import categories from '@/constants/categories.js';
import calculators from '@/constants/calculators.enum.js';
import mixin from '@/mixin/index.js';
import entitiesServices from '@/services/entities.services.js';
import calculatorsLabels from "@/constants/labels/calculators.labels.js";
const { CONTINUOUS_INFUSION_ID } = calculatorsLabels;
const root = { root: true };
const CALCULATOR_ID = 7;

const getDrugsConcentration = async ({ state, commit, dispatch }, id) => {
    if (id === CONTINUOUS_INFUSION_ID && !state.drugsConcentrations) {
        try {
            commit("general/setLoadingOn", true, root);
            const payload = await entitiesServices.getItem('configuration', 'drugs_concentrations');
            state.drugsConcentrations = payload.drugs;
        } catch {
            dispatch("general/showError", null, root);
            return false;
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    }
    return true;
}
const setCalculator = async (modules, id) => {
    const { dispatch, commit } = modules;
    const calculator = mixin.methods._filterArrayFromId(calculators, id)[0];
    if (!calculator) {
        dispatch("general/showError", null, root);
        dispatch('general/routeBack', null, root);
        throw new Error();
    }
    commit("setCalculator", calculator);
    const analyticsEvents = { name: 'openCalculatorByName', object: { 'name': calculator.name } };
    dispatch("general/logEvent", analyticsEvents, root);
    return calculator;
}
const openCalculatorById = async (modules, { id, redirect = true }) => {
    const { dispatch, commit } = modules;
    commit("setCalculator", null);
    await commit('drugs/setCategory', mixin.methods._filterArrayFromId(categories, CALCULATOR_ID)[0], root);
    const hasAccess = await modules.dispatch('topics/openTopicItem', { itemId: id, topicId: 'calculators', redirectMode: redirect }, root);
    const hasDrugsConcentrations = await getDrugsConcentration(modules, id);
    if (!hasAccess || !hasDrugsConcentrations) {
        return;
    }

    const calculator = await setCalculator(modules, id);
    commit("setCalculatorParameters", null);
    if (redirect) {
        const action = calculator.routeName ? 'general/routeRedirect' : 'general/routePathRedirect';
        const payload =
            calculator.routeName ? { name: calculator.routeName } : { path: "/calculators/" + calculator.id };
        dispatch(action, payload, root);
    }
    modules.dispatch('general/showDisclaimer', null, root);
}
export default {
    openCalculators: async ({ commit, dispatch }) => {
        dispatch("general/logEvent", 'openCalculators', root);
        await commit('drugs/setProductsSummary', {}, root);
        await commit('drugs/setDrugsSummary', { calculators }, root);
        await commit('drugs/setCategory', mixin.methods._filterArrayFromId(categories, CALCULATOR_ID)[0], root);
    },
    openCalculatorById,
    setCalculator,
    addDrugToContinuousInfusion: function ({ state }, { drug, previousId }) {
        state.drugs = mixin.methods._removeFromArrayWithId(state.drugs, previousId);
        state.drugs.push(drug);
    },
    deleteDrugFromContinuousInfusion: function ({ state }, id) {
        state.drugs = mixin.methods._removeFromArrayWithId(state.drugs, id);
    },
}